import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Text } from '../../components/Text';
import Hint from '../../components/ModuleDrawer/Hint';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { SelectControl } from '../../components/controls/SelectControl';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const StyledAnswerRow = styled.div`
  width: 80%;
`;

const creditScoreSpec = {
  field_type: 'single_choice',
  options: [700, 450, 600, 675, 725, 800],
  option_data: {
    '700': { label: 'Not Sure' },
    '450': { label: 'Below 550' },
    '600': { label: '550-649 (Poor)' },
    '675': { label: '650-699 (Fair)' },
    '725': { label: '700-749 (Good)' },
    '800': { label: '750 & Above (Excellent)' },
  },
};

class CreditScore extends Component {
  constructor(props) {
    super(props);
    this.state = { creditScore: props.qna_hash.creditScore ? props.qna_hash.creditScore.answer : '700' };
  }

  componentDidMount() {
    this.props.pathAware('creditScore');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.creditScore) {
      this.setState({
        creditScore: props.qna_hash.creditScore.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        creditScore: {
          question: 'How is your credit score?',
          answer: this.state.creditScore,
        },
      })
      .then(onContinue);
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  onChange = (evt, field) => {
    this.setState({ [field]: evt.target.value });
  };

  render() {
    const { qna_hash, wrapper } = this.props;

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">How is your credit score?</Text>
        </div>
        <div
          style={{ width: '90%', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Text use="body1">
            Your credit score can help you get a lower rate on your debt, saving you thousands in interest payments.
          </Text>
        </div>
        <StyledAnswerRow>
          <SelectControl
            id="creditScore"
            style={{ maxWidth: '700px' }}
            label="Your Credit Score"
            value={this.state.creditScore}
            spec={creditScoreSpec}
            onChange={evt => this.onChange(evt, 'creditScore')}
          />
        </StyledAnswerRow>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(CreditScore);
